import styles from './PillarCard.module.css';

interface PillarCardProps {
  icon: string;
  title: string;
  description: string;
  points?: string[];
}

export function PillarCard({ icon, title, description, points }: PillarCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
        <span className={styles.icon} aria-hidden="true">{icon}</span>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      {points && points.length > 0 && (
        <ul className={styles.points}>
          {points.map((pt) => (
            <li key={pt} className={styles.point}>
              <span className={styles.pointDot} aria-hidden="true" />
              {pt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
